import { IApplicationDefinition } from '@apps-config/app-definition';
import { History } from 'history';
import { TReducers } from '@telstra-connect/billing/reducers';
import { IFeatureFlagWithBVT } from '@telstra-connect/utils/bvt-feature-flags/bvt-flags';

type TGetSessionDetails = () => { sessionId: string; };
interface IApplications {
    [IncidentManagment: string]: {};
    Billing: {
        application: boolean;
        IntBillingPageAbleFeature: boolean;
        applicationInternational: boolean;
        invoiceBannerInternational: boolean;
        usageTypeCodes: string[];
        dropDownLatest: boolean;
        fileDownloadPanel: boolean;
        /* Feature Pack Graphs feature flags (Not to be deleted) */
        featurePackGraph: boolean;
        billingEnquiryInt: boolean;
        creditFootNote: boolean;
        adjustmentCreditRefundAndTransfer: boolean;
        showAlertBanner: boolean;
        customProdIssueAlert: string;
        cidnInUrl: boolean;
        billingEnquiryNewFormInt: boolean;
        trackEnquiryLink: boolean;
        enquiryTabText: boolean;
        enquiryFormWithComplexTable: boolean;
        attachmentsEnquiryForm: boolean;
        BillingTileMsg: boolean;
        tAnalystRedesign: boolean;
        showEnquiryList: boolean;
        showAttachmentList: boolean;
        triggerLargeLegacyDownloadOnTimeout: boolean;
        enquiryListLongDesc: boolean;
        scrollToNewEnqFromAdjustment: boolean;
        exportInvoicesForLegacy: boolean;
        lifecycleDrillDownPage: boolean;
        inactiveAccount: boolean;
        iotRecurringType: boolean;
        slicingRecurringType: boolean;
        iotCSVDownload: boolean;
        invoiceGreaterThanEighteenMonth: boolean;
        urls: {
            'T-Analyst': string;
        },
        customProperties: {
            't-analyst': boolean;
        },
        enquiryCSVEnabled: boolean;
        showServiceIdOrderDetails: boolean;
        newInvoiceNotifyFeature: boolean;
        offerNameFromAPIEnabled: boolean;
        extraDownloadOptions: boolean;
        shouldShowGenericAlertForIOT: boolean;
        offerNameFromUsageAPIEnabled: boolean;
        disableInvoicePDFDownloadForLegacy: boolean;
        shouldUpdateGraphHeading: boolean;
        invoiceStrategicEighteenMonth: boolean;
        shouldUpdateLifeCycleHeading: boolean;
        fileDownloadPanelSingleCsv: boolean;
        shouldDownloadZipToDevice: boolean;
        strategicFilterNoResult: boolean;
        oldInvoiceEnquiryOptions: boolean;
        showDigitalManagedService: boolean;
        detailedCsvFileRequest: boolean;
        enquiryConfirmationNewPage: boolean;
        newEnquiryOptions: boolean;
        ted269EnquiryMapping: boolean;
        ted_102_ZeroChargeCSV: boolean;
        newBadgeWithToolTip: boolean;
        tAnalystReportErrorRedirect: boolean;
        newBadgeInMobileWithToolTip: boolean;
        TED350GraphqlEndpoint: string;
        pdfDownloadErrorWithLink: boolean;
        TED1035NextUrlAPI: boolean;
        newBadgeWithToolTipInvoice: boolean;
        showErrorOnDirectDebitFailed: boolean;
        TED3204PayByCcLegacy: boolean;
        TED3204ShowPaymentNewAble: boolean;
        isShortfallcc: boolean;
        TEDIG950proRatedCharge: boolean;
        TEDT36263ShowHomePageAble: boolean;
        drilldownAbleChange: boolean;
        TEDIG3655LegacyPayment: boolean;
        TED2556YourDiscountOnTc: boolean;
        TEDIG3206PaymentMethodPage: boolean;
        TEDIG3343TransactionalNps: boolean;
        TEDIG3206LegacyPaymentStatus: boolean;
        TEDIG4958OnceOffCharges: boolean;
        enableMyBillPreBillStatus: boolean;
        TEDIG1512NonStandardPayment: boolean;
        TEDIG5906LastPaymentMethodNewErrorCode: boolean;
        TEDIG7717SingleInvoiceView: IFeatureFlagWithBVT;
        SCMT4353ExportDataModal: boolean;
        InvoiceStrategicAble: boolean;
        enableCTBillFlow: boolean;
    };
    Platform: {
        sideMenu: boolean;
        channelCareDirect: boolean;
        isTestCustomer: string[]
    }
}

export enum TransactionType {
    DOWNLOADING_BILLING_INVOICE = 'DOWNLOADING_BILLING_INVOICE'
}

declare const global: {
    TCONN: {
        getAppRoutingHistory: () => History,
        getSessionDetails: TGetSessionDetails,
        attachApplication:
        (ApplicationName: string, Application: IApplicationDefinition, Reducers: TReducers) => void;
        Platform: {
            isSecureAuth: boolean,
            showTNPSModal: (transactionType: TransactionType) => void
            resolveTargetURL: (targetURL: string) => string;
        },
        Billing: {
            GetApplication: () => IApplicationDefinition,
            GetReducers: () => TReducers,
        }
    },
    applications: IApplications
}

export default global;
